import { DataPeriods } from '@utils/dataPeriods';
import { UniversalTrackerValuePlain, ValueHistory } from '@g17eco/types/universalTrackerValue';
import { ValueAggregation } from '@g17eco/core';


export const valueAggregationMap: { [key in ValueAggregation]: string } = {
  [ValueAggregation.ValueSumAggregator]: 'Sum of all answers',
  [ValueAggregation.ValueAverageAggregator]: 'Average of all answers',
  [ValueAggregation.ValueConcatenateAggregator]: 'Concatenate all answers',
  [ValueAggregation.ValueListCountAggregator]: 'Count',
  [ValueAggregation.TextCountAggregator]: 'Count',
  [ValueAggregation.ValueCountAggregator]: 'Count',
  [ValueAggregation.NumericValueListSumAggregator]: 'Sum of all answers',
  [ValueAggregation.TableColumnAggregator]: 'Table',
  [ValueAggregation.TableConcatenationAggregator]: 'Table concatenation',
  [ValueAggregation.LatestAggregator]: 'Data from the latest answered metric',
  [ValueAggregation.EmptyAggregator]: 'Empty',
  [ValueAggregation.TableRowGroupAggregator]: 'Group rows by unique columns',
  [ValueAggregation.NumericValueListAverageAggregator]: 'Average of all answers',
  [ValueAggregation.TextAISummaryAggregator]: 'AI Summary',
};

type UtrvPick = Pick<UniversalTrackerValuePlain,  | 'initiativeId' | 'period' | 'status' | 'effectiveDate'>;
type HistoryPick = Pick<ValueHistory, 'value' | 'valueData' | 'action' | 'date' | 'unit' | 'numberScale'>;
export interface HistoryData extends HistoryPick, UtrvPick {
  utrvId: string;
  /** utrv.compositeData.surveyId **/
  surveyId?: string;
  // We fall back on to the utrv period if not set, therefore, always set
  period: DataPeriods;

  latestHistory?: HistoryPick;
}
